module.exports = __webpack_public_path__ + "img/stock6.98cc44da.png";